import React, {useState} from 'react';
import s from './styles.module.css'
import Wrapper from "../../../components/wrapper";
import {observer} from "mobx-react-lite";
import {CircularProgress} from "@mui/material";
import {useStore} from "../../../hooks/useStore";
import PasswordModal from "../../../components/dialog_modal/passwordmadal";

const Header = observer(() => {
    const store = useStore()
    const [visualRemoveCompetition, setVisualRemoveCompetition] = useState(false);
    const [openDialog, setOpenDialog] = React.useState(false);
    const [password, setPassword] = React.useState(0);

    const removeCompetition = async () => {
        setVisualRemoveCompetition(true);
        setOpenDialog(false);
        await store.judging.removeCompetition(password);
        setVisualRemoveCompetition(false);
    }

    return (
        <div className={s.header}>
            <Wrapper>
                <div className={s.header_split}>
                    <div className={s.header_data}>
                        <div>
                            <h1 style={{fontSize: '18px'}}
                                className={s.name}>{store?.global?.status?.competition_name || ''}</h1>
                        </div>
                    </div>

                </div>

            </Wrapper>
            <div className={s.wrappen_btns_reload}>
                {store?.global?.status?.server_type !== "view" &&
                    <button disabled={visualRemoveCompetition} className={s.btn_remove}
                            onClick={() => setOpenDialog(true)}>
                        Удалить сохранённое соревнование
                        {visualRemoveCompetition &&
                            <CircularProgress style={{position: "absolute", marginLeft: "130px", marginTop: "20px"}}
                                              size="12px" color="inherit"/>}
                    </button>
                }
            </div>

            <PasswordModal
                title="Вы действительно хотите удалить соревнование?"
                open={openDialog} setOpen={setOpenDialog} setPassword={setPassword} handlerConfirm={removeCompetition}/>
        </div>
    );
});

export default Header;
